import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AcessoMenu from '../../../components/acesso-menu';
import FlexCard from '../../../components/flex-card';
import useDispatchWithResult from '../../../hooks/useDispatchWithResult';
import AuthenticatedLayout from '../../../layouts/authenticated';
import { acessoSelector, fetchAcessos } from '../../../store/acessos';
import { isOperadorSelector } from '../../../store/autenticacao';
import { alertasByEmpresaIdSelector, empresasFiltradasSelector, fetchEmpresas, filtradoSelector, limparEmpresas } from '../../../store/empresas';
import { fetchTabela } from '../../../store/complianceTabela';
import EmpresasTable from './_EmpresasTable';
import PesquisaMenu from "../../../components/pesquisa-menu";
import ComplianceMenu from "../../../components/compliance-menu";
import ComplianceFiltroForm from "../filtro/_ComplianceFiltroForm";

export default function ComplianceTabelaPage() {
  const isOperador = useSelector(isOperadorSelector);
  const acesso = useSelector(acessoSelector);
  const empresas = useSelector(empresasFiltradasSelector);
  const filtrado = useSelector(filtradoSelector);
  const alertasByEmpresaId = useSelector(alertasByEmpresaIdSelector);
  const dispatch = useDispatchWithResult();
  const acessoId = acesso?.id;

  useEffect(() => {
    dispatch(fetchAcessos({ modulo: 'compliance' }));
  }, []);

  useEffect(() => {
    if (acessoId || filtrado)
      dispatch(fetchEmpresas({ acessoId, modulo: 'compliance' }));
    else
      dispatch(limparEmpresas());
  }, [acessoId]);

  useEffect(() => {
    dispatch(fetchTabela({ empresas, alertasByEmpresaId }));
  }, [empresas, alertasByEmpresaId]);

  return (
    <AuthenticatedLayout
      modulo="compliance"
      menu={
        <>
          <AcessoMenu defaultRoute="/compliance/tabela" fetchEmpresas modulo="compliance"/>
          {acessoId > 0 && <PesquisaMenu/>}
          <ComplianceMenu showCreate={isOperador} showFilter/>
        </>
      }
    >
      <FlexCard>
        <ComplianceFiltroForm/>
        <EmpresasTable/>
      </FlexCard>
    </AuthenticatedLayout>
  );
}
